import React from 'react';
import ErreurList from './erreurs/ErreurList';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';

function Monitorer() {
  const isMobile = window.innerHeight > window.innerWidth;

  return (
    <Container maxWidth={false} className={isMobile ? 'conteneur-accueil-mobile' : 'conteneur-accueil'}>
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Paper className="paperFull" style={{ padding: 16 }}>
            <Typography variant="h5">Surfaces operationnelles</Typography>
            <Button
              component={Link}
              to="/Operations/IncidentsCamera"
              variant="contained"
              color="primary"
              style={{ marginTop: 12 }}
            >
              Ouvrir Incidents cameras
            </Button>
            <Button
              component={Link}
              to="/cockpit"
              variant="contained"
              color="secondary"
              style={{ marginTop: 12, marginLeft: 12 }}
            >
              Cockpit operationnel
            </Button>
            <Button
              component={Link}
              to="/cockpit/investigation"
              variant="outlined"
              color="primary"
              style={{ marginTop: 12, marginLeft: 12 }}
            >
              Investigation detaillee
            </Button>
            <Button
              component={Link}
              to="/cockpit/laboratoire-interpretation/flux"
              variant="outlined"
              color="primary"
              style={{ marginTop: 12, marginLeft: 12 }}
            >
              Laboratoire interpretation
            </Button>
            <Button
              component={Link}
              to="/cockpit/graphe-cognitif"
              variant="outlined"
              color="primary"
              style={{ marginTop: 12, marginLeft: 12 }}
            >
              Graphe cognitif
            </Button>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper className="paperFull">
            <ErreurList />
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Monitorer;



// WEBPACK FOOTER //
// src/components/Monitorer.js